import { render } from "./date.vue?vue&type=template&id=6196d33e&scoped=true"
import script from "./date.vue?vue&type=script&lang=js"
export * from "./date.vue?vue&type=script&lang=js"

import "./date.vue?vue&type=style&index=0&id=6196d33e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2045206811/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6196d33e"]])

export default __exports__